/* eslint-disable */
import {lazy} from 'react';


export default {
};
